import * as React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useAppSelector } from '../../store/hooks'
import { selectAuthenticatedUser, selectAuthenticatedUserTokenExpiration } from '../../store/auth/authSlice'
import { CountdownTimer } from '../CountdownTimer/CountdownTimer'
import './GhostingBanner.scss'

export const GhostingBanner: React.FC = () => {
  const user = useAppSelector(selectAuthenticatedUser)
  const tokenExpiration = useAppSelector(selectAuthenticatedUserTokenExpiration)
  const isGhosting = user?.isGhosted && !user?.demoMode

  if (!isGhosting) {
    return null
  }

  return (
    <>
      <div className='ghost-banner-spacer' />
      <Row className='zocks-bg-color-danger zocks-text-white pt-2 pb-2 ghost-banner'>
        <Col className='d-flex gap-4 justify-content-center align-items-center'>
          <div>
            You are ghosting: {user?.firstName} {user?.lastName}
          </div>
          {tokenExpiration ? (
            <div>
              <CountdownTimer targetDate={tokenExpiration * 1000} />
            </div>
          ) : null}
        </Col>
      </Row>
    </>
  )
}
